var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "46px",
    viewBox: "0 0 92 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "switch copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "landing-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing_final",
    transform: "translate(-1348.000000, -1640.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "switch-copy",
    transform: "translate(1348.000000, 1640.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9615479,46 C85.5256483,46 35.871799,46 23,46 C10.2974508,46 0,35.7025492 0,23 C0,10.2974508 10.2974508,0 23,0 C35.8731554,0 85.5280219,0 91.9645996,0 M91.9688721,3 C85.5313449,3 35.8750543,3 23,3 C11.954305,3 3,11.954305 3,23 C3,33.9306357 11.7687286,42.813225 22.6555106,42.9970929 L23,43 C35.8908963,43 85.5590685,43 92.0045166,43",
    id: "Rectangle",
    fill: "#0099C6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#0099C6",
    strokeWidth: 3,
    cx: 25,
    cy: 23,
    r: 8.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch2);
export default __webpack_public_path__ + "static/media/switch2.d592b5b72bd95d0582fe62c461016a4a.svg";
export { ForwardRef as ReactComponent };